<div class="container mt-4">
    <h2 class="text-center mb-4">Asset Clearance Approvers</h2>

    <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th>Asset Function</th>
                    <th>Approver</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let approval of ExitRequestApprovals">
                    <td>{{ approval.checkListDescription }}</td>
                    <td>{{ approval.approverEmail }}</td>
                    <td>
                    <button class="btn btn-primary" (click)="openChangeApproverModal(approval)">
                        Change Approver
                    </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>


<!-- Change Approver Modal -->
<nz-modal 
  [(nzVisible)]="isChangeApproverModalVisible" 
  nzTitle="Change Approver" 
  [nzWidth]="600" 
  (nzOnCancel)="closeChangeApproverModal()"
  (nzOnOk)="confirmApproverChange(selectedUser)"
>
  <div *nzModalContent>
    <label for="userDropdown">Select New Approver:</label>
    <ng-select  [(ngModel)]="selectedUser" aria-placeholder="Select Employee">
        <!-- <option value="">-- Select New Approver --</option> -->
      <ng-option [value]="user" *ngFor="let user of userList" >
        {{ user.firstName }} - ({{ user.email }})
      </ng-option>
    </ng-select>
  </div>
</nz-modal>

